import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

import "../../css/footer.css";
import imgFacebook from "../../images/facebook.svg";
import imgInstagram from "../../images/instagram.svg";

const Footer = (props) => {
    const [resources, setResources] = useState({});
    const { language } = useParams();

    useEffect(() => {
        requestResources();
    }, [language]);

    const requestResources = async () => {
        try {
            const res = await axios.get(`form/resources/${language}`);
            setResources(res.data?.translation);
        } catch (error) {
            console.error(error?.response?.data);
        }
    };

    return (
        <>
            <footer className="madame-footer">
                <div className="footer-content wrapper">
                    <div className="footer-links">
                        <a href="https://www.madamebissegger.ch/agb" className="footer-link">AGB</a>
                        <a href="https://www.madamebissegger.ch/newsletter-1" className="footer-link">Newsletter</a>
                        <a href="https://www.madamebissegger.ch/impressum" className="footer-link">Impressum</a>
                        <a href="https://www.madamebissegger.ch/datenschutz" className="footer-link">Datenschutz</a>
                        <a href="https://www.madamebissegger.ch/tickets" className="footer-link">Tickets</a>
                    </div>
                    <div className="footer-social">
                        <a href="https://www.facebook.com/TheaterMadameBissegger" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Facebook">
                            <img className="social-icon" src={imgFacebook} alt="Facebook" />
                        </a>
                        <a href="https://www.instagram.com/madame_bissegger/?locale=fr_FR&hl=en" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Instagram">
                            <img className="social-icon" src={imgInstagram} alt="Instagram" />
                        </a>
                    </div>
                    
                </div>
            </footer>
        </>
    );
};

export default Footer;
